import { listInventoryItemsApi } from 'api/inventory';
import { inventoryDashboardActions } from 'store/slices/inventoryDashboardSlice';
import { handleError } from './errorHandlerThunks';

const loadInventoryItems = () => (dispatch) => {
  dispatch(inventoryDashboardActions.setLoading(true));
  return listInventoryItemsApi({ filter: {} })
    .then((items) => {
      dispatch(inventoryDashboardActions.setInventoryItems(items));
      dispatch(inventoryDashboardActions.setLoading(false));
    })
    .catch((error) => {
      dispatch(inventoryDashboardActions.setLoading(false));
      dispatch(handleError({ error }));
    });
};

export default loadInventoryItems;
